module.exports = __webpack_public_path__ + "img/rooftop.ef5356c4.jpeg";